import { PatchBoardsTemplateActionApiResponse, openapi } from "../../../../openapi";

const patchIssueBoardTemplate = (
  draft: { template?: PatchBoardsTemplateActionApiResponse["template"] } | undefined,
  updatedTemplate: PatchBoardsTemplateActionApiResponse,
) => {
  if (draft == null) return;
  draft.template = updatedTemplate.template;
};

openapi.enhanceEndpoints({
  endpoints: {
    patchBoardsTemplateAction: {
      async onQueryStarted({ body }, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedTemplate } = await queryFulfilled;
          const { projectId, boardId } = body;

          dispatch(
            openapi.util.updateQueryData(
              "getProjectByProjectIdIssueboardAndIssueBoardId",
              { projectId, issueBoardId: boardId },
              (draft) => {
                patchIssueBoardTemplate(draft, updatedTemplate);
              },
            ),
          );

          dispatch(
            openapi.util.updateQueryData("getProjectByProjectIdIssueboard", { projectId }, (draft) => {
              const board = draft.find((item) => item._id === boardId);
              patchIssueBoardTemplate(board, updatedTemplate);
            }),
          );
        } catch {
          // The caller handles user-facing errors. Leave cache untouched on failed status updates.
        }
      },
    },
  },
});
